// Models
import ComDetails from '../model/comDetails';

import {
    FETCH_NOTIFICATION_EVENT_SUCCESS,
    FETCH_NOTIFICATION_EVENT_ERROR,
    ADD_COMM_PROFILE_SUCCESS,
    ADD_COMM_PROFILE_ERROR,
    FETCH_COMM_PROFILE_SUCCESS,
    FETCH_COMM_PROFILE_ERROR,
    UPDATE_COMM_PROFILE_SUCCESS,
    UPDATE_COMM_PROFILE_ERROR,
    HIDE_COMM_PROFILE_LOADER,
    SHOW_COMM_PROFILE_LOADER,
} from './commProfile.constants';

export const initialState = {
    notificationEvents: {
        eventList: [],
    },
    isLoading: false,
    error: {},
    addCommProfile: {
        isSuccess: false,
        error: {},
        isLoading: false,
    },
    updateCommProfile: {
        isSuccess: false,
        error: {},
        isLoading: false,
    },
};

export const commProfileReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_NOTIFICATION_EVENT_SUCCESS: {
            return {
                ...state,
                notificationEvents: { eventList: [...action.payload] },
            };
        }
        case FETCH_NOTIFICATION_EVENT_ERROR:
            return {
                ...state,
                notificationEvents: { ...action.payload },
            };
        case ADD_COMM_PROFILE_SUCCESS: {
            return {
                ...state,
                addCommProfile: { isSuccess: true, ...action.payload },
            };
        }
        case ADD_COMM_PROFILE_ERROR:
            return {
                ...state,
                addCommProfile: { isSuccess: false, ...action.payload },
            };
        case UPDATE_COMM_PROFILE_SUCCESS: {
            return {
                ...state,
                updateCommProfile: { isSuccess: true, ...action.payload },
            };
        }
        case UPDATE_COMM_PROFILE_ERROR:
            return {
                ...state,
                updateCommProfile: { isSuccess: false, ...action.payload },
            };
        case FETCH_COMM_PROFILE_SUCCESS: {
            const commDetails = new ComDetails(action.payload);
            return {
                ...state,
                ...commDetails,
                error: {},
            };
        }
        case FETCH_COMM_PROFILE_ERROR:
            return {
                ...state,
                ...action.payload,
            };
        case SHOW_COMM_PROFILE_LOADER:
            return { ...state, isLoading: true };
        case HIDE_COMM_PROFILE_LOADER:
            return { ...state, isLoading: false };
        default:
            return state;
    }
};
